import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, ArrowRight } from "lucide-react";
import { company, navLinks, providers, providerOrder } from "../mock/mock";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      {/* CTA strip */}
      <div className="brand-gradient">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white text-2xl font-bold">
              End-to-End Support for Your Business VoIP Phone System!
            </h3>
            <p className="text-blue-100 mt-1">
              Free consultation, reliable & experienced engineers. (Cloud hosted VoIP solutions)
            </p>
          </div>
          <a
            href={`mailto:${company.salesEmail}?subject=Business%20VoIP%20Phone%20System%20Consultation`}
            className="inline-flex items-center gap-2 bg-white text-blue-800 font-semibold px-6 py-3 rounded-full hover:bg-blue-50 transition-colors shrink-0"
          >
            Email our Sales Engineer <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="h-10 w-10 rounded-xl brand-gradient flex items-center justify-center">
              <Phone className="h-5 w-5 text-white" />
            </div>
            <div className="leading-tight">
              <div className="font-bold text-white">Morrisville</div>
              <div className="text-[10px] font-semibold tracking-[0.18em] text-blue-400 uppercase">
                Communications
              </div>
            </div>
          </div>
          <p className="text-sm text-slate-400">{company.tagline}</p>
          <a
            href={company.linkedin}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 mt-4 text-sm text-slate-300 hover:text-white"
          >
            <Linkedin className="h-4 w-4" /> LinkedIn
          </a>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            {navLinks.slice(0, 3).map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="hover:text-white transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link>
            </li>
            <li>
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Providers</h4>
          <ul className="space-y-2 text-sm">
            {providerOrder.map((slug) => (
              <li key={slug}>
                <Link to={`/providers/${slug}`} className="hover:text-white transition-colors">
                  {providers[slug].name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-blue-400 shrink-0" />
              <span>{company.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-blue-400 shrink-0" />
              <a href={`tel:${company.phoneTel}`} className="hover:text-white">{company.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-blue-400 shrink-0" />
              <a href={`mailto:${company.email}`} className="hover:text-white break-all">{company.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>Copyright {"\u00A9"} 2026 {company.legalName} - All Rights Reserved.</span>
          <span>{company.tagline}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
